import { useState, useEffect } from "react";
import { loadAllStateList, loadCountryList, loadStateListbyCountryID } from "../services/locationService";

const useStateList = (editID) => {

    const [stateList, setStateList] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedStateID, setSelectedStateID] = useState(null);
    const [isStateDataLoaded, setIsStateDataLoaded] = useState(false);

    // fetch state by country id
    const fetchStateListbyCountryID = async (selectedID = null, country_id = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_countryid: country_id, };

        try {
            const data = await loadStateListbyCountryID(para);
            if (data && data.length > 0) {
                setStateList(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedState(initialDepartment);
                    setSelectedStateID(initialDepartment.id);
                    setIsStateDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Fetch department data
    const fetchStateList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadAllStateList(para);
            if (data && data.length > 0) {
                setStateList(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedState(initialDepartment);
                    setSelectedStateID(initialDepartment.id);
                    setIsStateDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isStateDataLoaded && editID === 0) {
            const loadStates = async () => {
                await fetchStateList();
            };
            loadStates();
        }
    }, [isStateDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadStateByID = async (selectedID) => {
        await fetchStateList(selectedID);
    };

       // Function to load department based on selected ID
    const loadStateByCountryID = async (selectedID,countryID) => {
        await fetchStateListbyCountryID(selectedID,countryID);
    };

    return {
        stateList,
        selectedState,
        selectedStateID,
        setSelectedState,
        setSelectedStateID,
        loadStateByID,
        loadStateByCountryID
    };
};

export default useStateList;
